import { Flex, IconButton, Text } from "@chakra-ui/react"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"

const FlashcardAdd = (props) => {
  return (
    <Flex
      onClick={props.addFlashCard}
      padding="0.7rem"
      height={"100%"}
      width={"100%"}
      backgroundColor="blackAlpha.100"
      direction={"column"}
      justify={"center"}
      alignItems={"center"}
      transition={"background-color 0.3s"}
      cursor={"pointer"}
      _hover={{
        backgroundColor: "blackAlpha.200"
      }}
    >
      <IconButton
        height="30px"
        mb="0.3rem"
        minWidth="2em"
        icon={<Pathicon icon="plus-circle" style={{ fontSize: "2.5em" }} />}
        isRound
        aria-label="Add flashcard"
        color="blackAlpha.900"
      />
      <Text mt="0.3rem" color={"blackAlpha.900"}>
        Add flashcard
      </Text>
    </Flex>
  )
}

export default FlashcardAdd
